import { FiPlus, FiEdit, FiSave, FiSearch, FiFileText, FiFile } from 'react-icons/fi';
import { useEffect, useState } from 'react';

const DockVerticalDerecha = ({
  handleBotonCrear,
  handleBotonEditar,
  handleBotonGuardar,
  handleBotonBuscar,
  handleBotonPDF,
  handleBotonTXT,
  guardando = false,
}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  const botones = [
    { icon: <FiPlus size={20} />, tooltip: 'Modo creación', onClick: handleBotonCrear },
    { icon: <FiEdit size={20} />, tooltip: 'Modo edición', onClick: handleBotonEditar },
    {
      icon: <FiSave size={20} className={guardando ? 'animate-pulse' : ''} />,
      tooltip: guardando ? 'Guardando...' : 'Guardar cambios',
      onClick: handleBotonGuardar,
      // Deshabilitado mientras se espera la respuesta del backend: evita que un
      // doble clic (usuario pensando que el primero no registró) dispare un
      // segundo submit y duplique la factura/compra/registro.
      disabled: guardando
    },
    { icon: <FiSearch size={20} />, tooltip: 'Buscar', onClick: handleBotonBuscar },
    { icon: <FiFileText size={20} />, tooltip: 'Exportar CSV', onClick: handleBotonPDF },
    { icon: <FiFile size={20} />, tooltip: 'Exportar TXT DGII 606', onClick: handleBotonTXT },
  ].filter(boton => boton.onClick);

  return (
    <div
      className={`fixed right-6 top-1/4 flex flex-col space-y-4 z-50 transition-transform duration-500 ${
        visible ? 'translate-x-0' : 'translate-x-20 opacity-0'
      }`}
    >
      {botones.map((boton, index) => (
        <div key={index} className="group relative">
          <button
            type="button"
            onClick={boton.onClick}
            disabled={boton.disabled}
            className="bg-color-primario text-white p-3 rounded-xl hover:bg-color-secundario transition-all shadow-md hover:shadow-lg flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-color-primario"
          >
            {boton.icon}
          </button>
          <span className="absolute right-full mr-2 px-3 py-1 bg-gray-800 text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap">
            {boton.tooltip}
          </span>
        </div>
      ))}
    </div>
  );
};

export default DockVerticalDerecha;
